module.exports = __webpack_public_path__ + "f1c85073813fd7af2472965ff075278b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-5.png
// module id = 3016
// module chunks = 0